import React, { useState, useEffect } from "react";
import { Button, Col, Row, Container } from "react-bootstrap";
import { capitalize } from "lodash-es";
import CustomTooltip from "utils/CustomTooltip";
import PlatformSpecific from "./PlatformSpecific";

function ApiAccess(props) {
  // Simplified platform state handling
  const [platforms, setPlatforms] = useState(props.api_platforms);
  const [mccId, setMccId] = useState(props.organization.google_ads_mcc_id);
  const [showAlert, setShowAlert] = useState(false);

  useEffect(() => {
    const googleAds = platforms.google_ads;
    const showAlertCondition = googleAds.authenticated && (!mccId || mccId.length !== 10);
    setShowAlert(showAlertCondition);
  }, [platforms.google_ads, mccId]);


  const openAuthPage = (authUrl) => {
    window.open(authUrl, "_blank");
  };

  const renderAuthButton = (platformKey) => {
    const platform = platforms[platformKey];
    const isGoogleService = platform.title.toLowerCase().includes("google");
  
    if (platform.authenticated) {
      return (
        <>
          <Button className="mb-4 btn-lg api-button text-center" variant="danger" onClick={() => openAuthPage(platform.deauth_url)}>
            Reset Token
            <CustomTooltip faClass="text-white far fa-question-circle f18 pl-2" message={`Resetting ${capitalize(platform.title)} token will require you to authenticate again`} inline={true} />
          </Button>
        </>
      );
    } else if (isGoogleService) {
      const googleBtn = require("images/google/btn_google_signin_light_normal_web.png");
      return (
        <div onClick={() => openAuthPage(platform.auth_url)}>
          <img className="api-google-button mx-auto mb-4" src={`/datapulse${googleBtn}`} alt="Google Sign-In" />
        </div>
      );
    } else {
      return (
        <>
          <Button className="mb-4 api-button btn-lg text-center" variant="success" onClick={() => openAuthPage(platform.auth_url)}>
            Authenticate
            <i className="fas fa-cog pl-2" style={{ paddingRight: "0px", color: "unset", float: "unset" }}></i>
          </Button>
        </>
      );
    }
  };

  return (
    <>
      <Container fluid className="p-0 pt-0 px-4 trim-padding api-access sec-bg">
        <Row className="d-flex mx-0 pt-4 pl-4 pr-4 pb-0 trim-padding">
          <Col xs={12} className="pl-md-4 pl-0 pr-0 pr-md-3 mb-5 pb-2 basic-info-container prim-bg">
            <div className="pt-4 pb-2 mb-3 px-3">
              <h5>Authenticate with the services you need to pull for your clients.</h5>
              <p>Note: Access to Amazon Seller Central and Shopify platforms is handled on the account level. Please go to Account Settings to authorize them.</p>
            </div>
            <Row style={{ maxWidth: "1400px", margin: "0 auto" }} className="mt-5 api-container mb-5">
              {Object.keys(platforms).map((platformKey, index) => {
                const platform = platforms[platformKey];
                const apiTitle = platformKey === "google_webmasters" ? "Google Search Console" : platform.title;
                return (
                  <Col key={index} xs={12} sm={6} className="text-center api-access-col">
                    <h4>{apiTitle}</h4>
                    {renderAuthButton(platformKey)}
                  </Col>
                );
              })}
            </Row>
          </Col>
        </Row>
        <PlatformSpecific showAlert={showAlert} mccId={mccId} setMccId={setMccId} {...props} />
      </Container>
    </>
  );
}

export default ApiAccess;